var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1667 3H24.9583C23.7735 3.00288 22.7659 3.8653 22.5802 5.0355L7.8777 8.18599C7.52349 7.2486 6.62707 6.62744 5.625 6.625H4.41667C3.08252 6.6263 2.0013 7.70752 2 9.04167V18.7083C2.0013 20.0425 3.08252 21.1237 4.41667 21.125H5.625C6.42074 21.1244 7.16509 20.7317 7.61482 20.0753L9.25532 20.3682V23.5417C9.25531 24.081 9.61278 24.5551 10.1314 24.7034L14.3552 25.9118C14.7199 26.0137 15.1112 25.9409 15.4149 25.7147C15.7177 25.4864 15.8958 25.1292 15.8958 24.75V21.554L22.584 22.7483C22.7848 23.9033 23.786 24.7474 24.9583 24.75H26.1667C27.5008 24.7487 28.582 23.6675 28.5833 22.3333V5.41667C28.582 4.08252 27.5008 3.0013 26.1667 3ZM5.625 18.7083H4.41667V9.04167H5.625V18.7083ZM22.5417 7.51578L8.04167 10.6229V17.6967L22.5417 20.286V7.51578ZM13.4792 23.1476L11.672 22.6307V20.8001L13.4792 21.1225V23.1476ZM24.9583 22.3333H26.1667V5.41667H24.9583V22.3333Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaign);
export default __webpack_public_path__ + "static/media/compaign.d0c66db2.svg";
export { ForwardRef as ReactComponent };